import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient"; // centralized client

// Fetch all invoices
export const fetchBillInvoices = createAsyncThunk(
  "billInvoices/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.get("/bill-invoices/");
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Create a new invoice
export const createBillInvoice = createAsyncThunk(
  "billInvoices/create",
  async (invoiceData, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.post("/bill-invoices/", invoiceData);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Update an invoice
export const updateBillInvoice = createAsyncThunk(
  "billInvoices/update",
  async ({ id, ...fields }, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.put(`/bill-invoices/${id}`, fields);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Delete an invoice
export const deleteBillInvoice = createAsyncThunk(
  "billInvoices/delete",
  async (id, { rejectWithValue }) => {
    try {
      await apiClient.delete(`/bill-invoices/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const billInvoiceSlice = createSlice({
  name: "billInvoices",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchBillInvoices.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchBillInvoices.fulfilled, (s, a) => { s.loading = false; s.data = a.payload; })
      .addCase(fetchBillInvoices.rejected, (s, a) => { s.loading = false; s.error = a.payload; })

      // CREATE
      .addCase(createBillInvoice.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(createBillInvoice.fulfilled, (s, a) => {
        s.loading = false;
        s.data.push(a.payload);
      })
      .addCase(createBillInvoice.rejected, (s, a) => { s.loading = false; s.error = a.payload; })

      // UPDATE
      .addCase(updateBillInvoice.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(updateBillInvoice.fulfilled, (s, a) => {
        s.loading = false;
        const idx = s.data.findIndex((inv) => inv.id === a.payload.id);
        if (idx !== -1) s.data[idx] = a.payload;
      })
      .addCase(updateBillInvoice.rejected, (s, a) => { s.loading = false; s.error = a.payload; })

      // DELETE
      .addCase(deleteBillInvoice.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(deleteBillInvoice.fulfilled, (s, a) => {
        s.loading = false;
        s.data = s.data.filter((inv) => inv.id !== a.payload);
      })
      .addCase(deleteBillInvoice.rejected, (s, a) => { s.loading = false; s.error = a.payload; });
  },
});

export default billInvoiceSlice.reducer;
